export const checkCheckoutReady = () => {
  return (
    window.mainConfig.merchantData.payment_method_count > 0 &&
    window.mainConfig.merchantData.delivery_option_count > 0
  );
};

export const getProductQuantityOfStockHintSetting = () => {
  // NOTE: The backend ssr output a string, so it needs to be converted to string
  const stockReminderActivation = String(
    window.mainConfig.merchantData?.order_setting?.stock_reminder_activation,
  );
  return stockReminderActivation === 'true';
};
